/* eslint-disable no-undef */
import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './app/App.js';

globalThis.isDev = import.meta.env.MODE === 'development';
globalThis.isProd = import.meta.env.MODE === 'production';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
